import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrow360 = () => {
  return (
    <g>
      <path d="m10.4021 3.3418a.75.75 0 1 0 -.0576 1.498 4.2814 4.2814 0 0 1 -.167 8.56h-4.3545a4.2813 4.2813 0 1 1 0-8.5625h.2044l-.78.7705a.75.75 0 1 0 1.0551 1.0661l2.0775-2.0539a.75.75 0 0 0 .01-1.0566l-2.1769-2.2362a.75.75 0 0 0 -1.0751 1.0469l.9375.9629h-.2525a5.7812 5.7812 0 1 0 0 11.5625h4.3545a5.781 5.781 0 0 0 .2246-11.5576z" />
    </g>
  );
};

export default withIcon(IconArrow360);
